// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"179aeceb","453":"1a8cfeba","455":"45622f61","977":"60c90dc5"}[chunkId] + ".chunk.js";
};